/**
 * @generated SignedSource<<b818f814c27e1080c50f7f9f75ed7ea2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type SlotType = "BUCKET" | "MULTI" | "QUEUE" | "SINGLE";
export type BookingWizardQueryRendererQuery$variables = {
  bookingId?: string | null | undefined;
  bookingType: BookingType;
  clubSlug: string;
  currentDate: string;
  facilityId: string;
  lessonTypeId?: string | null | undefined;
  memberId: string;
  membershipTypeId: string;
  players?: ReadonlyArray<string | null | undefined> | null | undefined;
  slotId: string;
  slotType?: SlotType | null | undefined;
};
export type BookingWizardQueryRendererQuery$data = {
  readonly club: {
    readonly " $fragmentSpreads": FragmentRefs<"BookingWizardUIHeaderFragment">;
  } | null | undefined;
  readonly currentServerTime: string;
  readonly node: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AddPlayersStepNode" | "BookingWizardUIFooterFragment" | "TimeSlotWizardStepContainerNode" | "useInitializeBookingWizardNode">;
  } | null | undefined;
  readonly session: {
    readonly currentClientProfile: {
      readonly " $fragmentSpreads": FragmentRefs<"AddPlayersPrivateStepClientProfile" | "AddPlayersStepClientProfile" | "PreviousBookingsStepClientProfile">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useInitializeBookingWizardSession">;
  } | null | undefined;
};
export type BookingWizardQueryRendererQuery = {
  response: BookingWizardQueryRendererQuery$data;
  variables: BookingWizardQueryRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clubSlug"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentDate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lessonTypeId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "players"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotType"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentServerTime",
  "storageKey": null
},
v12 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "clubSlug"
  }
],
v13 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "slotId"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = {
  "kind": "Variable",
  "name": "memberId",
  "variableName": "memberId"
},
v16 = {
  "kind": "Variable",
  "name": "membershipTypeId",
  "variableName": "membershipTypeId"
},
v17 = {
  "kind": "Variable",
  "name": "forSlotId",
  "variableName": "slotId"
},
v18 = [
  (v17/*: any*/)
],
v19 = {
  "kind": "Variable",
  "name": "players",
  "variableName": "players"
},
v20 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v23 = {
  "kind": "Variable",
  "name": "bookingType",
  "variableName": "bookingType"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMins",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v26 = {
  "alias": "standardCapacity",
  "args": [
    {
      "kind": "Literal",
      "name": "bookingType",
      "value": "STANDARD"
    }
  ],
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": "capacity(bookingType:\"STANDARD\")"
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedCapacity",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v31 = {
  "kind": "Literal",
  "name": "type",
  "value": "CUSTOMER"
},
v32 = [
  (v16/*: any*/),
  (v31/*: any*/)
],
v33 = [
  (v22/*: any*/),
  (v14/*: any*/)
],
v34 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": (v33/*: any*/),
    "storageKey": null
  }
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holeCount",
  "storageKey": null
},
v37 = [
  (v14/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v21/*: any*/)
],
v38 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CourseLayoutEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CourseLayout",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v37/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v39 = [
  (v14/*: any*/)
],
v40 = {
  "kind": "Literal",
  "name": "memberVisible",
  "value": true
},
v41 = [
  (v40/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "default",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v44 = {
  "kind": "Literal",
  "name": "bookingType",
  "value": "LESSON"
},
v45 = {
  "kind": "Variable",
  "name": "lessonTypeId",
  "variableName": "lessonTypeId"
},
v46 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "NINE"
  }
],
v47 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "EIGHTEEN"
  }
],
v48 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "enabled",
      "value": true
    },
    {
      "kind": "Variable",
      "name": "validOnDate",
      "variableName": "currentDate"
    }
  ],
  "concreteType": "SquareCardOnFileConnection",
  "kind": "LinkedField",
  "name": "squareCards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFileEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareCardOnFile",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v43/*: any*/),
            (v42/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expYear",
              "storageKey": null
            },
            (v22/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cardBrand",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastFour",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v53 = [
  (v14/*: any*/),
  (v49/*: any*/),
  (v50/*: any*/),
  (v51/*: any*/),
  (v52/*: any*/)
],
v54 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v33/*: any*/),
  "storageKey": null
},
v56 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "REQUEST"
    ]
  }
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCloses",
  "storageKey": null
},
v59 = [
  (v14/*: any*/),
  (v22/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RequestConfig",
        "kind": "LinkedField",
        "name": "requestConfig",
        "plural": false,
        "selections": (v39/*: any*/),
        "storageKey": null
      }
    ],
    "type": "RequestRule",
    "abstractKey": null
  }
],
v60 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clientCanFulfillRequests",
    "storageKey": null
  },
  (v14/*: any*/)
],
v61 = [
  (v25/*: any*/)
],
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "Request",
  "kind": "LinkedField",
  "name": "request",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "bookingRule",
      "plural": false,
      "selections": (v59/*: any*/),
      "storageKey": null
    },
    (v14/*: any*/),
    (v25/*: any*/)
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesIndex",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesCount",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "dateLte",
      "variableName": "currentDate"
    },
    (v17/*: any*/),
    {
      "kind": "Variable",
      "name": "slotType",
      "variableName": "slotType"
    }
  ],
  "concreteType": null,
  "kind": "LinkedField",
  "name": "repeatableBookings",
  "plural": true,
  "selections": [
    (v22/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v22/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": [
                    (v22/*: any*/),
                    (v14/*: any*/),
                    (v50/*: any*/),
                    (v51/*: any*/),
                    (v52/*: any*/)
                  ],
                  "storageKey": null
                },
                (v14/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isBooking"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestScheduleBlockingScope",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v22/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": "configuredRequestRestrictions",
              "args": (v56/*: any*/),
              "concreteType": "AgendaBookingRulesConnection",
              "kind": "LinkedField",
              "name": "requestWindowBookingRules",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AgendaBookingRulesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v57/*: any*/),
                    (v58/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v59/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
            },
            (v14/*: any*/),
            (v28/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPublic",
                      "storageKey": null
                    },
                    (v14/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PrivateBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "privateBookingPermissionSet",
                  "plural": false,
                  "selections": (v60/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PublicBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "publicBookingPermissionSet",
                  "plural": false,
                  "selections": (v60/*: any*/),
                  "storageKey": null
                },
                (v29/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lessonsDisplayName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "lesson",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "singular",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Department",
                  "kind": "LinkedField",
                  "name": "department",
                  "plural": false,
                  "selections": [
                    (v29/*: any*/),
                    (v21/*: any*/),
                    (v14/*: any*/)
                  ],
                  "storageKey": null
                },
                (v21/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseConnection",
                  "kind": "LinkedField",
                  "name": "courses",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v14/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v14/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isSlot"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "configuredRequestRestrictions",
              "args": (v56/*: any*/),
              "concreteType": "SlotBookingRulesConnection",
              "kind": "LinkedField",
              "name": "requestWindowBookingRules",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SlotBookingRulesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v57/*: any*/),
                    (v58/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
            },
            (v25/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "groupLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "holeOffset",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BookingConnection",
              "kind": "LinkedField",
              "name": "bookings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BookingEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v22/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RoundConnection",
                          "kind": "LinkedField",
                          "name": "rounds",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RoundEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v22/*: any*/),
                                    (v14/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "player",
                                      "plural": false,
                                      "selections": [
                                        (v22/*: any*/),
                                        (v50/*: any*/),
                                        (v51/*: any*/),
                                        (v52/*: any*/),
                                        (v14/*: any*/)
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v14/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "course",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseBucket",
                  "kind": "LinkedField",
                  "name": "courseBucket",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v14/*: any*/)
                  ],
                  "storageKey": null
                },
                (v14/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v61/*: any*/),
          "type": "BucketTimeSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v62/*: any*/),
        (v63/*: any*/),
        (v64/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlot",
          "kind": "LinkedField",
          "name": "fullfillableSlots",
          "plural": true,
          "selections": (v39/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SlotConnection",
          "kind": "LinkedField",
          "name": "slots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SlotEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v22/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v61/*: any*/),
                      "type": "TimeSlot",
                      "abstractKey": null
                    },
                    (v14/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            (v29/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "agenda",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Club",
                      "kind": "LinkedField",
                      "name": "club",
                      "plural": false,
                      "selections": [
                        (v30/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v27/*: any*/),
                (v26/*: any*/)
              ],
              "type": "TimeSlot",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundConnection",
          "kind": "LinkedField",
          "name": "rounds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoundEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "player",
                      "plural": false,
                      "selections": [
                        (v49/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseLayout",
                      "kind": "LinkedField",
                      "name": "courseLayout",
                      "plural": false,
                      "selections": [
                        (v35/*: any*/),
                        (v21/*: any*/),
                        (v36/*: any*/),
                        (v14/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "nonPlayingHost",
                          "storageKey": null
                        }
                      ],
                      "type": "MemberRound",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v24/*: any*/)
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v62/*: any*/),
        (v63/*: any*/),
        (v64/*: any*/),
        (v24/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StaffProfileConnection",
          "kind": "LinkedField",
          "name": "instructors",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StaffProfileEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StaffProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v14/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StaffUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v49/*: any*/),
                        (v14/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LessonBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roomName",
          "storageKey": null
        }
      ],
      "type": "DiningBooking",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "slotId",
      "variableName": "slotId"
    }
  ],
  "concreteType": "TransportationType",
  "kind": "LinkedField",
  "name": "preferredTransportationType",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v43/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BookingWizardQueryRendererQuery",
    "selections": [
      (v11/*: any*/),
      {
        "alias": null,
        "args": (v12/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookingWizardUIHeaderFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v13/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AddPlayersStepNode"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInitializeBookingWizardNode"
          },
          {
            "args": [
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "TimeSlotWizardStepContainerNode"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookingWizardUIFooterFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "FragmentSpread",
            "name": "useInitializeBookingWizardSession"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v19/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "AddPlayersStepClientProfile"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AddPlayersPrivateStepClientProfile"
              },
              {
                "args": (v18/*: any*/),
                "kind": "FragmentSpread",
                "name": "PreviousBookingsStepClientProfile"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BookingWizardQueryRendererQuery",
    "selections": [
      (v11/*: any*/),
      {
        "alias": null,
        "args": (v12/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "logoImage",
            "plural": false,
            "selections": (v20/*: any*/),
            "storageKey": null
          },
          (v21/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v13/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          (v14/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requirePlayerCounts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "bookingId",
                    "variableName": "bookingId"
                  },
                  (v23/*: any*/),
                  (v15/*: any*/)
                ],
                "concreteType": "EndSlotOptionsConnection",
                "kind": "LinkedField",
                "name": "endSlotOptions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EndSlotOptionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "allowedPlayerCounts",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "availability",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "memberHoldEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "memberHoldDeadlineHours",
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "currentDefaultBookingRate",
                "args": (v32/*: any*/),
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "bookingRates",
                "plural": true,
                "selections": (v34/*: any*/),
                "storageKey": null
              },
              {
                "alias": "currentDefaultRate",
                "args": (v32/*: any*/),
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "playerRateForMembershipType",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Course",
                "kind": "LinkedField",
                "name": "course",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultBookingDurationMins",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseLayout",
                    "kind": "LinkedField",
                    "name": "defaultCourseLayout",
                    "plural": false,
                    "selections": (v37/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseLayoutConnection",
                    "kind": "LinkedField",
                    "name": "courseLayouts",
                    "plural": false,
                    "selections": (v38/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseBucket",
                    "kind": "LinkedField",
                    "name": "courseBucket",
                    "plural": false,
                    "selections": (v39/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "CourseLayoutConnection",
                "kind": "LinkedField",
                "name": "permittedCourseLayouts",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": "permittedCourseLayouts(memberVisible:true)"
              },
              (v29/*: any*/),
              {
                "alias": null,
                "args": [
                  (v23/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "capacity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedUntil",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v41/*: any*/),
                        "concreteType": "CourseLayoutConnection",
                        "kind": "LinkedField",
                        "name": "permittedCourseLayouts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseLayoutEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CourseLayout",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "memberVisible",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "permittedCourseLayouts(memberVisible:true)"
                      }
                    ],
                    "type": "TimeSlot",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "fields": [
                              (v44/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "facilityId",
                                "variableName": "facilityId"
                              },
                              (v45/*: any*/)
                            ],
                            "kind": "ObjectValue",
                            "name": "slotAvailability"
                          }
                        ],
                        "concreteType": "TimeSlotConnection",
                        "kind": "LinkedField",
                        "name": "startSlots",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeSlotEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeSlot",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": [
                                      (v44/*: any*/),
                                      (v45/*: any*/)
                                    ],
                                    "kind": "ScalarField",
                                    "name": "capacity",
                                    "storageKey": null
                                  },
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AvailabilitySlot",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          (v15/*: any*/),
                          (v40/*: any*/)
                        ],
                        "concreteType": "TransportationType",
                        "kind": "LinkedField",
                        "name": "transportationTypes",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v35/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "customCode",
                            "storageKey": null
                          },
                          (v21/*: any*/),
                          (v43/*: any*/),
                          {
                            "alias": "nineHolePrice",
                            "args": (v46/*: any*/),
                            "kind": "ScalarField",
                            "name": "totalPrice",
                            "storageKey": "totalPrice(holeCount:\"NINE\")"
                          },
                          {
                            "alias": "eighteenHolePrice",
                            "args": (v47/*: any*/),
                            "kind": "ScalarField",
                            "name": "totalPrice",
                            "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "rates",
                        "args": [
                          (v31/*: any*/),
                          {
                            "kind": "Variable",
                            "name": "visibleToMembershipTypeId",
                            "variableName": "membershipTypeId"
                          }
                        ],
                        "concreteType": "SlotRate",
                        "kind": "LinkedField",
                        "name": "playerRates",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rate",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v14/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "visibility",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  (v16/*: any*/)
                                ],
                                "kind": "ScalarField",
                                "name": "appliesToMembershipType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "nineHolePrice",
                            "args": (v46/*: any*/),
                            "kind": "ScalarField",
                            "name": "totalGolfPrice",
                            "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
                          },
                          {
                            "alias": "eighteenHolePrice",
                            "args": (v47/*: any*/),
                            "kind": "ScalarField",
                            "name": "totalGolfPrice",
                            "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "agenda",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Facility",
                            "kind": "LinkedField",
                            "name": "facility",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PublicBookingPermissionSet",
                                "kind": "LinkedField",
                                "name": "publicBookingPermissionSet",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "rateDisplay",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Slot",
                    "abstractKey": "__isSlot"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "type": "TimeSlot",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v48/*: any*/)
                ],
                "type": "MemberUser",
                "abstractKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "active",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 25
                          },
                          (v19/*: any*/)
                        ],
                        "concreteType": "ClientConnection",
                        "kind": "LinkedField",
                        "name": "clients",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v53/*: any*/),
                                    "type": "Member",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v53/*: any*/),
                                    "type": "Customer",
                                    "abstractKey": null
                                  },
                                  (v54/*: any*/),
                                  (v55/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientClass",
                    "storageKey": null
                  },
                  (v55/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isClient"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v48/*: any*/),
                      (v14/*: any*/),
                      (v65/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v66/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v54/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v65/*: any*/),
                      (v14/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v66/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroup",
                        "kind": "LinkedField",
                        "name": "memberGroups",
                        "plural": true,
                        "selections": (v39/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Member",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isClientProfile"
              },
              (v54/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "074a66a58e2160f826d15a42a96263a8",
    "id": null,
    "metadata": {},
    "name": "BookingWizardQueryRendererQuery",
    "operationKind": "query",
    "text": "query BookingWizardQueryRendererQuery(\n  $slotId: ID!\n  $membershipTypeId: ID!\n  $players: [ID]\n  $currentDate: Date!\n  $clubSlug: String!\n  $slotType: SlotType\n  $facilityId: ID!\n  $bookingType: BookingType!\n  $memberId: ID!\n  $lessonTypeId: ID\n  $bookingId: ID\n) {\n  currentServerTime\n  club(slug: $clubSlug) {\n    ...BookingWizardUIHeaderFragment\n    id\n  }\n  node(id: $slotId) {\n    __typename\n    id\n    ...AddPlayersStepNode\n    ...useInitializeBookingWizardNode\n    ...TimeSlotWizardStepContainerNode_4DhkMQ\n    ...BookingWizardUIFooterFragment\n  }\n  session {\n    ...useInitializeBookingWizardSession_Op49W\n    currentClientProfile {\n      __typename\n      ...AddPlayersStepClientProfile_zYVbD\n      ...AddPlayersPrivateStepClientProfile\n      ...PreviousBookingsStepClientProfile_Op49W\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment AddPlayersHeaderNode on Node {\n  __isNode: __typename\n  ... on TimeSlot {\n    requirePlayerCounts\n    standardCapacity: capacity(bookingType: STANDARD)\n    usedCapacity\n  }\n}\n\nfragment AddPlayersPrivateStepClientProfile on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    clientClass\n    ... on Member {\n      id\n      firstName\n      lastName\n      profileImage {\n        publicId: renderingKey\n      }\n      memberGroups {\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AddPlayersPrivateStepNode on Node {\n  __isNode: __typename\n  ...AddPlayersHeaderNode\n  ... on TimeSlot {\n    requirePlayerCounts\n    standardCapacity: capacity(bookingType: STANDARD)\n    usedCapacity\n    agenda {\n      facility {\n        type\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment AddPlayersStepClientProfile_zYVbD on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    club {\n      ...AddPlayers_Clients_zYVbD\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AddPlayersStepNode on Node {\n  __isNode: __typename\n  ... on QueueSlot {\n    __typename\n  }\n  ... on TimeSlot {\n    requirePlayerCounts\n  }\n}\n\nfragment AddPlayers_Clients_zYVbD on Club {\n  clients(first: 25, active: true, players: $players) {\n    edges {\n      node {\n        __typename\n        membershipType {\n          __typename\n          id\n        }\n        ... on Member {\n          id\n          fullName\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        ... on Customer {\n          id\n          fullName\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  id\n}\n\nfragment BookingCard_Booking on Booking {\n  __isBooking: __typename\n  __typename\n  id\n  requestScheduleBlockingScope\n  ...useShouldPresentBookingAsLockedRequest_booking\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        player {\n          __typename\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n          id\n        }\n      }\n    }\n  }\n  startSlot {\n    __typename\n    ...useHasUnpublishedRequestRestrictions_slot\n    agenda {\n      date\n      facility {\n        club {\n          supportsPublic\n          id\n        }\n        privateBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        publicBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        type\n        lessonsDisplayName\n        copyOverrides {\n          lesson {\n            singular\n          }\n        }\n        department {\n          type\n          name\n          id\n        }\n        name\n        courses {\n          count\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      time\n      groupLabel\n      holeOffset\n      bookings {\n        edges {\n          node {\n            __typename\n            rounds {\n              edges {\n                node {\n                  __typename\n                  id\n                  player {\n                    __typename\n                    firstName\n                    lastName\n                    profileImage {\n                      publicId: renderingKey\n                    }\n                    id\n                  }\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n      course {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n    ... on BucketTimeSlot {\n      time\n    }\n    id\n  }\n  ... on StandardBooking {\n    seriesIndex\n    seriesCount\n    fullfillableSlots {\n      id\n    }\n    status\n    slots {\n      edges {\n        node {\n          __typename\n          ... on TimeSlot {\n            time\n          }\n          id\n        }\n      }\n    }\n    request {\n      time\n      id\n    }\n  }\n  ... on LessonBooking {\n    seriesIndex\n    seriesCount\n    durationMins\n    request {\n      time\n      id\n    }\n    instructors {\n      edges {\n        node {\n          id\n          user {\n            fullName\n            id\n          }\n        }\n      }\n    }\n  }\n  ... on DiningBooking {\n    roomName\n  }\n}\n\nfragment BookingWizardUIFooterFragment on Node {\n  __isNode: __typename\n  ...WizardFooter_Node\n}\n\nfragment BookingWizardUIHeaderFragment on Club {\n  ...ClubLogo_Club\n  name\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment BundledTransportationTypeSelectNode_4DhkMQ on Slot {\n  __isSlot: __typename\n  transportationTypes(memberId: $memberId, memberVisible: true) {\n    id\n    code\n    customCode\n    name\n    enabled\n    nineHolePrice: totalPrice(holeCount: NINE)\n    eighteenHolePrice: totalPrice(holeCount: EIGHTEEN)\n  }\n  rates: playerRates(type: CUSTOMER, visibleToMembershipTypeId: $membershipTypeId) {\n    rate {\n      __typename\n      id\n      name\n      visibility\n      appliesToMembershipType(membershipTypeId: $membershipTypeId)\n    }\n    nineHolePrice: totalGolfPrice(holeCount: NINE)\n    eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n  }\n}\n\nfragment ClubLogo_Club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment CourseLayoutControlNode on Node {\n  __isNode: __typename\n  ... on TimeSlot {\n    agenda {\n      id\n      facility {\n        type\n        id\n      }\n    }\n    course {\n      defaultCourseLayout {\n        id\n        code\n        holeCount\n        name\n      }\n      id\n    }\n    permittedCourseLayouts(memberVisible: true) {\n      edges {\n        node {\n          id\n          default\n          enabled\n          holeCount\n          code\n          memberVisible\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment GroupSizeControlNode on Node {\n  __isNode: __typename\n  __typename\n  ... on TimeSlot {\n    type\n    standardCapacity: capacity(bookingType: STANDARD)\n    usedCapacity\n  }\n  ... on AvailabilitySlot {\n    id\n    startSlots(slotAvailability: {facilityId: $facilityId, bookingType: LESSON, lessonTypeId: $lessonTypeId}) {\n      edges {\n        node {\n          id\n          capacity(bookingType: LESSON, lessonTypeId: $lessonTypeId)\n          usedCapacity\n        }\n      }\n    }\n  }\n}\n\nfragment PreviousBookingsListClient_Op49W on Client {\n  __isClient: __typename\n  ... on Member {\n    id\n    repeatableBookings(dateLte: $currentDate, slotType: $slotType, forSlotId: $slotId) {\n      __typename\n      ... on StandardBooking {\n        id\n        startSlot {\n          __typename\n          type\n          ... on TimeSlot {\n            usedCapacity\n            standardCapacity: capacity(bookingType: STANDARD)\n          }\n          id\n        }\n        rounds {\n          edges {\n            node {\n              __typename\n              id\n              ... on MemberRound {\n                nonPlayingHost\n              }\n              player {\n                __typename\n                fullName\n                id\n              }\n            }\n          }\n        }\n      }\n      ...PreviousBookingsListItem\n      id\n    }\n  }\n  ... on Customer {\n    id\n    repeatableBookings(dateLte: $currentDate, slotType: $slotType, forSlotId: $slotId) {\n      __typename\n      ... on StandardBooking {\n        id\n        startSlot {\n          __typename\n          type\n          ... on TimeSlot {\n            usedCapacity\n            standardCapacity: capacity(bookingType: STANDARD)\n          }\n          id\n        }\n        rounds {\n          edges {\n            node {\n              __typename\n              id\n              ... on MemberRound {\n                nonPlayingHost\n              }\n              player {\n                __typename\n                fullName\n                id\n              }\n            }\n          }\n        }\n      }\n      ...PreviousBookingsListItem\n      id\n    }\n  }\n}\n\nfragment PreviousBookingsListItem on StandardBooking {\n  id\n  durationMins\n  rounds {\n    edges {\n      node {\n        __typename\n        courseLayout {\n          code\n          name\n          holeCount\n          id\n        }\n        player {\n          __typename\n          id\n          fullName\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        id\n      }\n    }\n  }\n  startSlot {\n    __typename\n    type\n    agenda {\n      date\n      facility {\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      time\n    }\n    id\n  }\n}\n\nfragment PreviousBookingsStepClientProfile_Op49W on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    ...PreviousBookingsListClient_Op49W\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment PreviousBookingsStep_TimeSlot on TimeSlot {\n  capacity(bookingType: $bookingType)\n  usedCapacity\n}\n\nfragment SquareCardFragment on SquareCardOnFile {\n  __typename\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n}\n\nfragment TimeSlotBookingDetailsStepNode_4DhkMQ on TimeSlot {\n  id\n  type\n  time\n  course {\n    courseBucket {\n      id\n    }\n    id\n  }\n  agenda {\n    id\n    facility {\n      club {\n        supportsPrivate\n        id\n      }\n      id\n    }\n  }\n  ...GroupSizeControlNode\n  ...CourseLayoutControlNode\n  ...TransportationTypeControlNode_4DhkMQ\n}\n\nfragment TimeSlotWizardStepContainerNode_4DhkMQ on Node {\n  __isNode: __typename\n  ...TimeSlotBookingDetailsStepNode_4DhkMQ\n  ...AddPlayersStepNode\n  ...AddPlayersPrivateStepNode\n  ...PreviousBookingsStep_TimeSlot\n}\n\nfragment TransportationTypeControlNode_4DhkMQ on Node {\n  __isNode: __typename\n  ... on Slot {\n    __isSlot: __typename\n    ...BundledTransportationTypeSelectNode_4DhkMQ\n    ...TransportationTypeSelectNode_iuAjk\n    agenda {\n      facility {\n        type\n        publicBookingPermissionSet {\n          rateDisplay\n          id\n        }\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    transportationTypes(memberId: $memberId, memberVisible: true) {\n      id\n      code\n      customCode\n      name\n      enabled\n      nineHolePrice: totalPrice(holeCount: NINE)\n      eighteenHolePrice: totalPrice(holeCount: EIGHTEEN)\n    }\n  }\n}\n\nfragment TransportationTypeSelectNode_iuAjk on Slot {\n  __isSlot: __typename\n  transportationTypes(memberId: $memberId, memberVisible: true) {\n    id\n    code\n    customCode\n    name\n    enabled\n    nineHolePrice: totalPrice(holeCount: NINE)\n    eighteenHolePrice: totalPrice(holeCount: EIGHTEEN)\n  }\n}\n\nfragment WizardFooter_Node on Node {\n  __isNode: __typename\n  __typename\n  ... on TimeSlot {\n    id\n    lockedUntil\n    agenda {\n      id\n    }\n  }\n}\n\nfragment useBookingPaymentCards_session_1gpj4o on Session {\n  user {\n    __typename\n    ... on MemberUser {\n      squareCards(enabled: true, validOnDate: $currentDate) {\n        edges {\n          node {\n            id\n            enabled\n            default\n            expMonth\n            expYear\n            ...SquareCardFragment\n          }\n        }\n      }\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        squareCards(enabled: true, validOnDate: $currentDate) {\n          edges {\n            node {\n              id\n              enabled\n              default\n              expMonth\n              expYear\n              ...SquareCardFragment\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGetRequiredWizardSteps_Op49W on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    ... on Member {\n      repeatableBookings(dateLte: $currentDate, slotType: $slotType, forSlotId: $slotId) {\n        __typename\n        id\n        rounds {\n          edges {\n            node {\n              __typename\n              player {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n        ...BookingCard_Booking\n      }\n    }\n    ... on Customer {\n      id\n      repeatableBookings(dateLte: $currentDate, slotType: $slotType, forSlotId: $slotId) {\n        __typename\n        id\n        rounds {\n          edges {\n            node {\n              __typename\n              player {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n        ...BookingCard_Booking\n      }\n    }\n    club {\n      clients(first: 25, active: true, players: $players) {\n        edges {\n          node {\n            __typename\n            ... on Member {\n              id\n            }\n            ... on Customer {\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useHasUnpublishedRequestRestrictions_slot on Slot {\n  __isSlot: __typename\n  __typename\n  ... on QueueSlot {\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n        }\n      }\n      id\n    }\n  }\n  ... on TimeSlot {\n    configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n      edges {\n        liftAt\n        requestCloses\n      }\n    }\n  }\n}\n\nfragment useInitializeBookingWizardNode on Node {\n  __isNode: __typename\n  ...useValidDurationsNode\n  ... on TimeSlot {\n    id\n    time\n    standardCapacity: capacity(bookingType: STANDARD)\n    usedCapacity\n    requirePlayerCounts\n    agenda {\n      date\n      facility {\n        memberHoldEnabled\n        memberHoldDeadlineHours\n        type\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    currentDefaultBookingRate: bookingRates(membershipTypeId: $membershipTypeId, type: CUSTOMER) {\n      rate {\n        __typename\n        id\n      }\n    }\n    currentDefaultRate: playerRateForMembershipType(membershipTypeId: $membershipTypeId, type: CUSTOMER) {\n      rate {\n        __typename\n        id\n      }\n    }\n    course {\n      id\n      name\n      defaultBookingDurationMins\n      defaultCourseLayout {\n        id\n        code\n        holeCount\n        name\n      }\n      courseLayouts {\n        edges {\n          node {\n            id\n            code\n            holeCount\n            name\n          }\n        }\n      }\n    }\n    permittedCourseLayouts(memberVisible: true) {\n      edges {\n        node {\n          id\n          code\n          holeCount\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment useInitializeBookingWizardSession_Op49W on Session {\n  ...useBookingPaymentCards_session_1gpj4o\n  currentClientProfile {\n    __typename\n    ...useGetRequiredWizardSteps_Op49W\n    member {\n      __typename\n      clientClass\n      membershipType {\n        __typename\n        id\n      }\n      ... on Member {\n        id\n        firstName\n        lastName\n        profileImage {\n          publicId: renderingKey\n        }\n        preferredTransportationType(slotId: $slotId) {\n          id\n          enabled\n        }\n      }\n      ... on Customer {\n        id\n        firstName\n        lastName\n        profileImage {\n          publicId: renderingKey\n        }\n        preferredTransportationType(slotId: $slotId) {\n          id\n          enabled\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useShouldPresentBookingAsLockedRequest_booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n          node {\n            id\n            __typename\n            ... on RequestRule {\n              requestConfig {\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n  ... on LessonBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment useValidDurationsNode on Node {\n  __isNode: __typename\n  ... on TimeSlot {\n    endSlotOptions(bookingId: $bookingId, bookingType: $bookingType, memberId: $memberId) {\n      edges {\n        durationMins\n        allowedPlayerCounts\n        node {\n          id\n          time\n          availability\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c8994e921bde1d523d8865603a99e82";

export default node;
